// extracted by mini-css-extract-plugin
export var root = "Character-module--root--gkTr2";